import { BankType, BrandType, Maybe, NegotiationOptionAlternative, NegotiationOptionAlternativeType, NegotiationType, Normative026 } from '../generated/graphql';

export const getNegotiationOptionLabel = (
  type: NegotiationType,
  bank?: BankType | undefined,
  _normative026?: Normative026, // deprecated
  alternative?: NegotiationOptionAlternative,
  brand?: Maybe<BrandType>,
) => {
  switch (type) {
    case NegotiationType.CatchUp: return 'Puesta al día';
    case NegotiationType.ConditionsRedefinition: return '';
    case NegotiationType.Modification: return 'Modificación';
    case NegotiationType.NoOptions: return '¡Queremos ayudarte!';
    case NegotiationType.Normalization: return 'Normalización';
    case NegotiationType.PaymentPromise: {
      if (bank === BankType.Bbva) return 'Acuerdo de pago mora';
      return 'Promesa de pago';
    }
    case NegotiationType.PenaltyPortfolioPaymentAgreement: return 'Acuerdo de pago de cartera';
    case NegotiationType.Refinance: {
      if (bank === BankType.BancoDeBogota) return 'Novación';
      if (bank === BankType.Bbva && alternative?.type === NegotiationOptionAlternativeType.Restructuring) return 'Reestructuración';
      if (bank === BankType.RappiPrestamo) return 'Modificado';
      return 'Rediferido';
    }
    // por alguna razón type era de tipo NegotiationType | Normative026 ???
    case (Normative026.Restructuring as unknown as NegotiationType): {
      if (bank === BankType.Scotiabank) return 'Ampliación de plazo - Reestructuración';
      return 'Reestructurado';
    }
    case (Normative026.Modification as unknown as NegotiationType): {
      if (bank === BankType.Scotiabank) return 'Ampliación de plazo - Modificación';
      return 'Modificado';
    }
    case NegotiationType.Restructure: return 'Reestructuración';
    case NegotiationType.TotalPayment: {
      if (brand === BrandType.Jcap || brand === BrandType.Pra) return 'Pago total';
      if (bank === BankType.BancoDeBogota) return 'Cancelación total';
      return 'Pago total con descuento';
    }
    case NegotiationType.InstallmentsPlan: {
      if (bank === BankType.BancoDeBogota) return 'Consolidación de productos';
      return 'Acuerdo de pago a plazos';
    }
    case NegotiationType.Condonation: return 'Condonación';
    case NegotiationType.ExpressRefinance: return 'Rediferido express';
    case NegotiationType.BalanceBehindPayment: return 'Pago Mora de Contado';
    case NegotiationType.TermExtension: return 'Ampliación de Plazo';
    default: return '';
  }
};
